export default __webpack_public_path__ + "static/media/BEN_logo.d135c43e.png";